import { Modal as ModalModule } from 'common';
import React, { useContext } from 'react';
import AccountCommunication from '../utils/AccountCommunication';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const RegionsModal = ({
	data: { editCategory, response, locations },
	modalId,
}) => {
	const { closeModal } = useContext(ModalContext);

	return (
		<Modal
			modalId={modalId}
			className="account-locations complete-modal"
			header="Process Completed"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'Ok',
				onClick: () => closeModal(modalId),
			}}
		>
			<div className="body">
				<div className="p-grid">
					{AccountCommunication.isSuccessful(response) && (
						<p className="p-col-12">
							Success. {editCategory} has been updated for {locations}{' '}
							Locations.
						</p>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default RegionsModal;
